import { Link } from 'react-router-dom';
import { usePageTitle } from '../../lib/usePageTitle';
import { AuthLayout } from '../../components/AuthLayout';

/** Informativa privacy (GDPR, lineeguida §57). Linguaggio semplice e onesto. */
export function PrivacyPage() {
  usePageTitle('Informativa privacy');
  return (
    <AuthLayout title="Informativa privacy">
      <div className="flex max-w-prose flex-col gap-4 text-ink-800 dark:text-ink-100">
        <p>
          Questa informativa spiega quali dati personali raccoglie PandaCalcio, perché e come li
          trattiamo, ai sensi del Regolamento UE 2016/679 (GDPR).
        </p>

        <h2 className="mt-2 text-xl font-bold">Titolare del trattamento</h2>
        <p>
          Il titolare è il gestore della piattaforma PandaCalcio. Per qualsiasi richiesta sulla
          privacy scrivi a <strong>privacy@pandacalcio.it</strong>.
        </p>

        <h2 className="mt-2 text-xl font-bold">Quali dati raccogliamo</h2>
        <ul className="list-disc pl-5">
          <li>
            <strong>Dati dell’account</strong>: email, nome visualizzato e password (conservata solo
            in forma cifrata, mai in chiaro).
          </li>
          <li>
            <strong>Dati di gioco</strong>: leghe a cui partecipi, pronostici, punteggi, classifiche
            e contestazioni.
          </li>
          <li>
            <strong>Dati tecnici</strong>: indirizzo IP e informazioni sul dispositivo nei registri
            di sicurezza (accessi, operazioni amministrative).
          </li>
          <li>
            <strong>Preferenze</strong>: impostazioni di accessibilità e di notifica che scegli tu.
          </li>
        </ul>

        <h2 className="mt-2 text-xl font-bold">Perché li usiamo</h2>
        <ul className="list-disc pl-5">
          <li>Per farti giocare: gestire account, leghe, pronostici e classifiche (esecuzione del contratto).</li>
          <li>Per inviarti email di servizio: verifica dell’account, recupero password, promemoria delle giornate (puoi disattivare i promemoria dalle preferenze).</li>
          <li>Per la sicurezza della piattaforma: registri di accesso e audit (legittimo interesse).</li>
        </ul>
        <p>Non vendiamo i tuoi dati e non facciamo profilazione pubblicitaria.</p>

        <h2 className="mt-2 text-xl font-bold">Statistiche di utilizzo</h2>
        <p>
          Usiamo <strong>Plausible Analytics</strong>, un servizio di statistiche rispettoso della
          privacy: non usa cookie, non traccia le persone tra un sito e l’altro e raccoglie solo
          dati aggregati e anonimi (pagine viste, provenienza, tipo di dispositivo). Per questo non
          è richiesto alcun banner di consenso.
        </p>

        <h2 className="mt-2 text-xl font-bold">Per quanto li conserviamo</h2>
        <p>
          Finché il tuo account è attivo. I registri tecnici di sicurezza vengono eliminati
          periodicamente. Se chiedi la cancellazione dell’account, i dati personali vengono rimossi
          o resi anonimi; i punteggi delle leghe restano in forma anonima per non falsare le
          classifiche altrui.
        </p>

        <h2 className="mt-2 text-xl font-bold">I tuoi diritti</h2>
        <p>
          Puoi chiedere accesso, rettifica, cancellazione, limitazione e portabilità dei tuoi dati,
          oppure opporti al trattamento, scrivendo a privacy@pandacalcio.it. Hai anche il diritto di
          presentare reclamo al Garante per la protezione dei dati personali.
        </p>

        <h2 className="mt-2 text-xl font-bold">Dove sono i dati</h2>
        <p>
          I dati sono ospitati su server situati nell’Unione Europea. Non vengono trasferiti fuori
          dall’UE.
        </p>

        <p className="mt-2">
          Vedi anche la <Link to="/cookie" className="text-panda-700 underline dark:text-panda-300">cookie policy</Link>.
        </p>
        <p className="text-sm text-ink-600 dark:text-ink-300">Ultimo aggiornamento: 27 agosto 2026.</p>
      </div>
    </AuthLayout>
  );
}
